import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LiveTranslatePipe } from './live-translate-pipe';

@NgModule({
  declarations: [LiveTranslatePipe],
  exports: [LiveTranslatePipe],
  imports: [CommonModule],
  providers: [LiveTranslatePipe],
})
export class LiveTranslateModule {}
